<template>
  <div class="egov-modal js-egov-modal" @click="cancel()">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="egov-modal__bg js-egov-modal-close"></div>
    <div class="egov-modal__content" @click="stopEvent()">
      <div class="egov-modal__header">
        <a class="egov-modal__close js-egov-modal-close" @click="cancel()"></a>
      </div>
      <div class="l-headding is-blueline">{{ lawName.lawName }}</div>
      <!-- 項を設定していない場合 -->
      <div class="egov-modal__body" v-if="provisionDetail.ApplData.LawContents.Article">
        <div style="margin-left: 1em; font-weight: bold;">{{ provisionDetail.ApplData.LawContents.Article.ArticleCaption }}</div>

        <template v-if="Array.isArray(provisionDetail.ApplData.LawContents.Article.Paragraph)">
          <div style="margin-left: 1em; text-indent: -1em;" v-for="(paragraph, index) in provisionDetail.ApplData.LawContents.Article.Paragraph" :key=index>
            <span v-if="index == 0" style="font-weight: bold;">{{ provisionDetail.ApplData.LawContents.Article.ArticleTitle }}</span>
            <span v-else style="font-weight: bold;">{{ paragraph.attributes.Num }}</span>
            <template v-if="!Array.isArray(paragraph.ParagraphSentence.Sentence)">
              &nbsp;{{ paragraph.ParagraphSentence.Sentence }}
            </template>
            <template v-else>
              &nbsp;
              <span v-for="(sentence, index) in paragraph.ParagraphSentence.Sentence" :key="index">
                {{ sentence }}
              </span>
            </template>
            <div v-if="paragraph.Item">
              <div style="margin-left: 1em; text-indent: -1em;" class="_div_ItemSentence" v-for="item in paragraph.Item" :key="item.ItemTitle">
                <span style="font-weight: bold;">{{ item.ItemTitle }}</span>&nbsp;{{ item.ItemSentence.Sentence }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="margin-left: 1em; text-indent: -1em;">
            <span style="font-weight: bold;">{{ provisionDetail.ApplData.LawContents.Article.ArticleTitle }}</span>
<!--
            <span style="font-weight: bold;">{{ provisionDetail.ApplData.LawContents.Article.Paragraph.attributes.Num }}</span>
-->
            <template v-if="!Array.isArray(provisionDetail.ApplData.LawContents.Article.Paragraph.ParagraphSentence.Sentence)">
              &nbsp;{{ provisionDetail.ApplData.LawContents.Article.Paragraph.ParagraphSentence.Sentence }}
            </template>
            <template v-else>
              &nbsp;
              <span v-for="(sentence, index) in provisionDetail.ApplData.LawContents.Article.Paragraph.ParagraphSentence.Sentence" :key="index">
                {{ sentence }}
              </span>
            </template>
            <div v-if="provisionDetail.ApplData.LawContents.Article.Paragraph.Item">
              <div style="margin-left: 1em; text-indent: -1em;" class="_div_ItemSentence" v-for="item in provisionDetail.ApplData.LawContents.Article.Paragraph.Item" :key="item.ItemTitle">
                <span style="font-weight: bold;">{{ item.ItemTitle }}</span>&nbsp;{{ item.ItemSentence.Sentence }}
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- 項まで指定している場合はこっち -->
      <div class="egov-modal__body" v-else>
        <div style="margin-left: 1em; font-weight: bold;">{{ provisionDetail.ApplData.Article }}</div>
        <div style="margin-left: 1em;">
          <template v-if="!Array.isArray(provisionDetail.ApplData.LawContents.Paragraph.ParagraphSentence.Sentence)">
            <span style="font-weight: bold;">{{ provisionDetail.ApplData.LawContents.Paragraph.attributes.Num }}</span>
            &nbsp;{{ provisionDetail.ApplData.LawContents.Paragraph.ParagraphSentence.Sentence }}
          </template>
          <template v-else>
            &nbsp;
            <span v-for="(sentence, index) in provisionDetail.ApplData.LawContents.Paragraph.ParagraphSentence.Sentence" :key="index">
              {{ sentence }}
            </span>
          </template>
          <div v-if="provisionDetail.ApplData.LawContents.Paragraph.Item">
            <div style="margin-left: 1em; text-indent: -1em;" class="_div_ItemSentence" v-for="item in provisionDetail.ApplData.LawContents.Paragraph.Item" :key="item.ItemTitle">
              <span style="font-weight: bold;">{{ item.ItemTitle }}</span>&nbsp;{{ item.ItemSentence.Sentence }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      diagItem: {

      },
      lawName: {
        lawName: ''
      },
      provisionDetail: {
        ApplData: {
          Article: '',
          LawContents: {
            Article: {
              ArticleCaption: '',
              ArticleTitle: '',
              Paragraph: [
                {
                  attributes: {
                    Num: null,
                    OldNum: false,
                  },
                  ParagraphSentence: {
                    Sentence: ''
                  },
                  Item: [
                    {
                      attributes: {
                        Num: null,
                      },
                      ItemTitle: '',
                      ItemSentence: {}
                    }
                  ]
                }
              ]
            }
          }
        }
      }
    }
  },
  props: {
    itemId: {}
  },
  created: function () {
    this.getProvisionDetail(this.itemId);
  },
  methods: {
    async getProvisionDetail(itemId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/diag/getProvisionDetail', {
        itemId: itemId,
      });
      if (res) {
        this.diagItem = res.data.diagItem;
        this.provisionDetail = res.data.provisionDetail;
        this.lawName = res.data.lawName;
      }
      this.isProcessing = false;
    },
    cancel() {
      this.$emit("hide-egov-provision-modal");
    },
    stopEvent() {
      event.stopPropagation()
    },
  }
}

</script>